import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import caseTypeSlaLookups from "./json/caseTypeSlaLookup.json";
import foiEventTypeLookups from "./json/foiEventTypeLookups.json";
import {
  API_HOST_FOI,
  API_HOST_USERS,
  API_HOST_REFDATA,
  API_HOST_PE,
  API_HOST_GUIDANCE,
  API_HOST_COMPLAINTS,
  API_HOST_COMMS,
  API_HOST_SARS,
} from "../config";
import { FoiService } from "./FoiService";
import foiStatusLookups from "./json/foiStatusLookups.json";
import complexityTypeLookups from "./json/complexityTypeLookups.json";

import legalInputLookups from "./json/legalInputLookups.json";
import complaintSourcesLookups from "./json/complaintsSources.json";
import complaintTypeLookups from "./json/complaintTypes.json";

import { UserService } from "./UserService";
import { QualificationTypeService } from "./QualificationTypeService";
import { CountriesService } from "./CountriesService";
import { GuidanceService } from "./GuidanceService";
import { refDataEndpoints, RefDataService } from "./RefDataService";
import { EventCommunicationTypeService } from "./EventTypeService";
import { PeService } from "./PeService";
import { ComplaintsService } from "./ComplaintsService";
import { ShareService } from "./ShareService";
import outcomeLookups from "./json/outcomeLookups.json";

// foi -> sar stuff
import { SarsService } from "./SarsService";
import sarsTypeLookups from "./json/sarsTypeLookups.json";
import citizenResponseTypes from "./json/citizenResponseTypes.json";
import formalResponseTypes from "./json/formalResponseTypes.json";
import foiStages from "./json/foiStageLookups.json";

export const foiService = new FoiService(API_HOST_FOI);
export const usersService = new UserService(API_HOST_USERS);
export const qualificationTypeService = new QualificationTypeService(
  API_HOST_REFDATA
);
export const countriesService = new CountriesService(API_HOST_REFDATA);
export const eventCommunicationTypeService = new EventCommunicationTypeService(
  API_HOST_REFDATA
);

// local lookups
export const foiStatusService = new LocalLookupService(foiStatusLookups);
export const foiStageService = new LocalLookupService(foiStages);
export const foiTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.foiType
);
export const foiCategoryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.category
);
export const peCategoryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.categoryPe
);
export const foiRagRatingService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.ragRating
);
export const foiSourceService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.source
);
export const customerTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.customerType
);
export const complexityTypeService = new LocalLookupService(
  complexityTypeLookups
);
export const caseTypeSlaService = new LocalLookupService(caseTypeSlaLookups);
export const foiEventTypeService = new LocalLookupService(foiEventTypeLookups);
export const citizenResponseTypeService = new LocalLookupService(
  citizenResponseTypes
);
export const formalResponseTypeService = new LocalLookupService(
  formalResponseTypes
);

export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);
// export const foiSeriesService = new FoiSeriesService(API_HOST_REFDATA);
// export const foiSeriesYearService = new FoiSeriesYearsService(API_HOST_REFDATA);
export const categoryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.category
);
export const directorateService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.gqVtq
);
export const learnerTypeService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.learnerType
);
export const exceptionalCircumstanceService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.exceptionalCircumstance
);
export const focusEnquiryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.focusOfEnquiry
);
export const themeEnquiryService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.themeOfEnquiry
);
export const gqvtqService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.gqVtq
);
export const exemptionsService = new RefDataService(
  API_HOST_REFDATA,
  refDataEndpoints.foiExemptions
);

export const peService = new PeService(API_HOST_PE);
export const legalInputService = new LocalLookupService(legalInputLookups);
export const complaintSourcesService = new LocalLookupService(
  complaintSourcesLookups
);
export const complaintTypeService = new LocalLookupService(
  complaintTypeLookups
);

export const complaintsService = new ComplaintsService(API_HOST_COMPLAINTS);

export const shareService = new ShareService(API_HOST_COMMS);

export const sarsService = new SarsService(API_HOST_SARS);
export const sarsTypeService = new LocalLookupService(sarsTypeLookups);

export const outcomeService = new LocalLookupService(outcomeLookups);
